const formatFormItemLabel = (text, showColon) =>
  `${text}${showColon ? ':' : ''}`

export default formatFormItemLabel
